import { Typography } from 'antd';
import styled from 'styled-components';
import { lightTheme } from '@/styles/themes/light';

const { Text } = Typography;
const { fonts } = lightTheme;

export const LabelText = styled(Text)`
	&& {
		font-size: 16px;
		font-weight: 600;
		line-height: 24px;
		color: #505050;
	}
`;

export const DividerVertical = styled.div`
	width: 1px;
	height: 56px;
	background-color: #e6e6e6;
	margin: 0 24px;
`;

export const SliderContainer = styled.div`
	width: 100%;
	padding: 0 12px;

	.ant-slider {
		margin: 8px 0;
	}

	.ant-slider-rail {
		height: 4px;
		background-color: #f0f0f0;
	}

	.ant-slider-track {
		height: 4px;
		background-color: #5474d1;
	}

	.ant-slider-handle {
		width: 16px;
		height: 16px;
		margin-top: -6px;
		background-color: #2f54eb;
		border: solid 2px #ffffff;
		box-shadow: 2px 2px 8px 0px #e6eaf8;
	}

	.ant-slider-mark-text {
		font-size: 14px;
		font-weight: 600;
		line-height: 16px;
		color: #262626;
		white-space: nowrap;
		transform: translateX(-50%);
	}

	.ant-slider-dot {
		width: 0;
		height: 0;
		border: none;
	}

	.ant-slider-mark {
		top: 20px;
	}
`;

export const EffectiveLoadContainer = styled.div`
	display: flex;
	gap: 8px;
	align-items: center;
	justify-content: flex-start;
`;

export const EffectiveLoadLabel = styled(Text)`
	&& {
		font-size: 16px;
		font-weight: 600;
		line-height: 24px;
		color: #262626;
		white-space: nowrap;
	}
`;

export const EffectiveLoadValue = styled.div`
	min-width: 56px;
	height: 40px;
	background-color: #f0f0f0;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px;
`;

export const EffectiveLoadText = styled.p`
	margin: 0;
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
	color: #505050;
	text-align: center;
`;

export const ScoreGroup = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const WeightRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 24px;
`;

export const WeightInputWrapper = styled.div`
	flex: none;
	width: 240px;
`;

export const CheckboxesWrapper = styled.div`
	flex: 1;
	min-width: 100%;

	@media (min-width: 1200px) {
		min-width: 0;
	}
`;

export const FactorDescriptionText = styled.span`
	font-size: ${fonts.label.md.fontSize} !important;
`;

export const RequiredAsterisk = styled.span`
	color: ${({ theme }) => theme.palette.risk.high.default};
`;

export const InfoIconWrapper = styled.span`
	font-size: ${fonts.body.md.fontSize};
	color: ${({ theme }) => theme.palette.secondary[400]};
	cursor: pointer;
	margin-right: 0px;
	margin-bottom: 9.33px;
`;